import type { MarketSelectorValue } from '../../../../MarketSelector/types';
import { getPriceGridMarketSelectorSelections } from '../common/getPriceGridMarketSelectorSelections';

export interface PrimeOrderMarketParams {
  selectedMarketAccounts: string[];
  selectedMarkets: string[];
  selectedAggregation?: string;
}

export function getPrimeOrderMarketParams({
  marketSelectorValue,
  marketsByName,
  marketAccountsByName,
}: {
  marketSelectorValue: MarketSelectorValue | undefined;
  marketsByName: ReadonlyMap<string, unknown>;
  marketAccountsByName: ReadonlyMap<string, unknown>;
}): PrimeOrderMarketParams {
  const { selectedMarkets, selectedMarketAccounts } = getPriceGridMarketSelectorSelections(
    marketSelectorValue,
    marketsByName,
    marketAccountsByName
  );

  return {
    selectedMarketAccounts,
    selectedMarkets,
    selectedAggregation: marketSelectorValue?.type === 'preset' ? marketSelectorValue.presetID : undefined,
  };
}
